import {useCallback, useEffect, useRef} from 'react'

import useMount from '@s-ui/react-hooks/lib/useMount/index.js'

export function useReopenDrawerOnSession({isEnabled, storageKey, onOpen, onToggleDrawer}) {
  const onToggleDrawerRef = useRef(onToggleDrawer)
  useEffect(() => {
    onToggleDrawerRef.current = onToggleDrawer
  })

  const handleVisibility = useCallback(() => {
    if (sessionStorage.getItem(storageKey)) {
      sessionStorage.removeItem(storageKey)
      onToggleDrawerRef.current(true)
    } else {
      onToggleDrawerRef.current(false)
    }
  }, [storageKey])

  useMount(() => {
    const navType = performance.getEntriesByType('navigation')[0]?.type
    if (isEnabled && navType === 'back_forward') {
      handleVisibility()
    }
  })

  useEffect(() => {
    const handlePageShow = event => {
      if (event.persisted && isEnabled) {
        handleVisibility()
      }
    }
    window.addEventListener('pageshow', handlePageShow)
    return () => window.removeEventListener('pageshow', handlePageShow)
  }, [handleVisibility, isEnabled, storageKey])
}
